<template>
  <!-- leftbar-tab-menu -->
  <div class="leftbar-tab-menu">
    <div class="main-icon-menu bg-primary">
      <div class="logo color-text" >
        <a v-if="$store.state.show_menu!==0" @click="changeShowMenu()" style="margin-right: 10px;font-size: 30px !important;">
          <i :class="$store.state.show_menu===1?'el-icon-s-fold':'el-icon-s-unfold'"></i>
        </a>
        <a v-else @click="routerTo(1,0,'/')">
          <img src="../../assets/logo_icon_none.png" style="height:40px" >
        </a>
      </div>
      <nav class="nav">
        <el-tooltip
          v-for="(menu_item,menu_key) in $store.state.menu" v-if="menu_item.is_show===1" :key="menu_key"
          :class="$store.state.now_menu[1]===menu_item.id?'nav_item active':'nav_item'" effect="light" :content="menu_item.name" placement="right">
          <span @click="routerTo(1,menu_item.id,menu_item.url)"><i :class="menu_item.icon"></i></span>
        </el-tooltip>
      </nav>
    </div>

    <div class="main-menu-inner" v-show="$store.state.show_menu===1">
      <div class="logo">
        <a @click="routerTo(1,0,'/')">
          <img src="../../assets/logo_text.png" style="height:40px" >
        </a>
      </div>
      <div class="menu-body">
        <div class="main-icon-menu-pane">
          <h6 class="menu-title color-primary" v-if="menuItem" >{{menuItem.name}}</h6>
          <ul v-if="menuItem">
            <li v-for="(menu_item_item,menu_item_key) in menuItem.child" v-if="menu_item_item.is_show===1" :key="menu_item_key">
              <a @click="routerTo(2,menu_item_item.id,menu_item_item.url)" :class="$store.state.now_menu[2]===menu_item_item.id?'menu-item-title active':'menu-item-title'">
                <span style="width: 100% !important;">{{menu_item_item.name}}</span>
                <span style="float: right">
                  <i :class="$store.state.now_menu[2]===menu_item_item.id?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
                </span>
              </a>
              <ul v-show="$store.state.now_menu[2]===menu_item_item.id">
                <li v-for="(menu_item_item_item,menu_item_item_key) in menu_item_item.child" v-if="menu_item_item_item.is_show===1" :key="menu_item_item_key">
                  <a :class="$store.state.now_menu[3]===menu_item_item_item.id?'menu-item-title-i active':'menu-item-title-i'" @click="routerTo(3,menu_item_item_item.id,menu_item_item_item.url)">{{menu_item_item_item.name}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: "LeftMenu",
    data(){
		  return {
        menuItem:{}
      }
    },
    mounted() {
      this.menuItem =  this.$store.state.menu.find(item=>item.id===this.$store.state.now_menu[1])
      let child = this.menuItem.child.filter(item => item.is_show===1)
      if (child.length!==0){
        this.$store.commit('setShowMenu',1)
      }else{
        this.$store.commit('setShowMenu',0)
      }
    },
    methods:{
      changeShowMenu(){
        let value = this.$store.state.show_menu===1?2:1
        this.$store.commit('setShowMenu',value)
      },
      routerTo(key,value,url=""){
        if (url!==""){
          this.$router.push({ path: url }).catch(err => err)
        }
        if (key===1){
          this.menuItem =  this.$store.state.menu.find(item=>item.id===value)
          this.$store.commit('setShowMenu',0)
          if (this.menuItem!==undefined){
            let child = this.menuItem.child.filter(item => item.is_show===1)
            if (child.length!==0){
              this.$store.commit('setShowMenu',1)
            }
          }
        }
      },
    }
	}
</script>

<style scoped>
  .leftbar-tab-menu{
    min-width: 70px;
    height: 100%;
    overflow: hidden;
  }
  .main-icon-menu{
    width: 70px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    float: left;
  }
  .main-icon-menu nav{
    flex: 1;
    flex-direction: column;
    align-items: center;
    padding: 5px 0;
    margin-top: 20px;
  }
  .main-icon-menu nav .nav_item{
    margin-top: 30px;
    font-size: 20px !important;
    color: #becae6;
    cursor: pointer;
    position: relative;
    padding: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main-icon-menu nav .nav_item:hover{
    color: #ffffff;
  }
  .main-icon-menu nav .nav_item.active{
    color: #ffffff;
  }
  .main-icon-menu nav .nav_item.active:before{
    content: "";
    position: absolute;
    left: 45px;
    top: 10px;
    border-right: 10px solid #ffffff;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
  }
  .main-menu-inner{
    width: 200px;
    height: 100%;
    float: left;
    background-color: #ffffff;
    border-right: 1px solid #eceff5;
    box-shadow: 0px 2px 4px rgba(31, 30, 47, 0.1);
  }
  .logo{
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .menu-body{
    height: auto !important;
    margin-top: 40px;
    padding: 20px;
  }
  .menu-body .main-icon-menu-pane{
    width: 100%;
    height: calc(100vh - 100px) !important;
    overflow: auto;
  }
  .menu-body .main-icon-menu-pane ul{
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    flex-direction: column;
  }
  .menu-body .main-icon-menu-pane ul li {
    position: relative;
    display: block;
  }
  .menu-item-title{
    cursor: pointer;
    position: relative;
    color: #5a5c61;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    height: 40px;
    border-radius: 3px;
    padding: 10px 15px;
  }
  .menu-item-title-i{
    cursor: pointer;
    position: relative;
    color: #5a5c61;
    font-size: 12px;
    font-weight: 400;
    display: flex;
    align-items: center;
    height: 30px;
    padding: 5px 30px;
  }
  .menu-item-title:hover,
  .menu-item-title-i:hover,
  .menu-item-title-i.active,
  .menu-item-title.active{
    color: #2AA5E0;
  }
  .menu-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 10px;
    line-height: 1;
    text-transform: uppercase;
  }
  .main-menu-inner.hidden{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/LeftMenu.vue